import declare from "dojo/_base/declare";
import Controller from "csi/action/Controller";
import lang from "dojo/_base/lang";
import { localStore } from "csi/state/rootStore";
import Request from "csi/def/Request";
import { CallMethod } from "csi/xml/CallMethod";
import xml from "csi/xml";
import { Action } from "csi/def/Action";
import { C8Node } from "csi/typings";

const FORMULATED_PRODUCT: string = "FormulatedProduct";
const FOOD_LABEL_UPDATE_UNIQUE_FLAT_INGREDIENTS: string = "FoodLabelUpdateUniqueFlatIngredients";

const FlatIngredientsToggleController = declare(Controller, {

	/**
	 * @override
	 * Add Parameter ParentURL to operation
	 */
	toWriterRequest() {
		const call: CallMethod = this.inherited<CallMethod>(arguments);
		call.addParameter("ParentURL", xml.ATTR_REF, this.getNode().$URL);
		return call;
	},

	/**
	 * @override
	 * Call reset flat ingredients operation if toggle button is toggling on, and ingredient items are modified in any way
	 */
	toWriter() {
		const action: Action = this.getAction();
		const ds: C8Node = this.getNode();
		const dsURL: string = ds.$URL;
		if (ds.LastModifiedTimeIngredients >= ds.LastCalculatedTimeFlatIngredients && !localStore.formulatedProduct.lastToggleStates.get(dsURL)) {
			const request: Request = lang.mixin(new Request(), {
				m_module: FORMULATED_PRODUCT,
				m_operation: FOOD_LABEL_UPDATE_UNIQUE_FLAT_INGREDIENTS,
			});

			action.m_request = request;
			this.inherited(arguments);
			return request;
		}
	},


});

export = FlatIngredientsToggleController;
